import { Input } from "@/components/ui";

export function CustomLeafTab({
  folder,
  leaf,
  onLeaf,
}: {
  folder: string | null;
  leaf: string | null;
  onLeaf: (leaf: string | null) => void;
}) {
  return (
    <div className="space-y-2 p-3">
      <p className="text-xs text-slate-500">
        Folder: {folder ?? "—"} (from the kind)
      </p>
      <Input
        aria-label="Leaf"
        value={leaf ?? ""}
        onChange={(e) => onLeaf(e.target.value.trim() || null)}
      />
    </div>
  );
}
